import { Injectable } from '@angular/core';

import { BetslipConfig } from '@frontend/sports/common/client-config-data-access';
import produce from 'immer';

import { IBetslipState } from '../../base/store/state';
import { BetBuilderPickId } from '../../core/picks/pick-id';
import { IBetslipPickStorage } from '../../core/picks/pick-models';
import BetslipDisplayModeService from '../../digital/services/betslip-display-mode.service';
import { IBetslipSavedState } from './betslip-state-model';

@Injectable()
export class BetslipSavedStateValidatorService {
    private readonly configuredDisplayMode = this.betslipDisplayModeService.betslipDisplayMode;
    constructor(
        private betslipConfig: BetslipConfig,
        private betslipDisplayModeService: BetslipDisplayModeService,
    ) {}

    validate(persistedState: IBetslipSavedState | undefined): IBetslipSavedState | undefined {
        const displayModeChanged = persistedState?.base?.displayMode !== this.configuredDisplayMode;
        const linearModeCheckboxesEnabledChanged =
            persistedState?.base?.linearModeCheckboxesEnabled !== this.betslipConfig.linearModeCheckboxesEnabled;
        const isBetBuilderStateCompatible =
            persistedState?.base?.isSportcastAsComboEnabled === this.betslipConfig.isSportcastAsComboEnabled ||
            !this.hasBetBuilderPicks(persistedState?.picks?.pickList);

        if (displayModeChanged || linearModeCheckboxesEnabledChanged || !isBetBuilderStateCompatible) {
            return;
        }

        return persistedState;
    }

    updateStateConfigs(betslipState: IBetslipState): IBetslipState {
        return produce(betslipState, (draft) => {
            draft.base.displayMode = this.configuredDisplayMode;
            draft.base.linearModeCheckboxesEnabled = this.betslipConfig.linearModeCheckboxesEnabled;
            draft.base.isSportcastAsComboEnabled = this.betslipConfig.isSportcastAsComboEnabled;
        });
    }

    private hasBetBuilderPicks(picks?: Partial<IBetslipPickStorage>[]): boolean {
        return picks?.some((pick) => BetBuilderPickId.isId(pick?.id ?? '')) ?? false;
    }
}
